<r-widget-control [control]="firstnameControl">
  <nz-range-picker
    [name]="config.name"
    [nzPlaceHolder]="config.placeholder"
    [nzAllowClear]="config.allowClear"
    [ngModel]="config.value | dateRangePipe"
    (ngModelChange)="onChange($event)"
    [nzFormat]="dateFormat"
    [required]="config.required"
    [disabled]="config.disabled"
    ngDefaultControl
    #firstnameControl="ngModel"
    style="width: 100%"
  ></nz-range-picker>
</r-widget-control>
